var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem1A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m169.67 94.61v-26.709h-65.274v2.4281h62.846v21.853h-62.846v2.4281h65.274zm422.07-47.42v-2.4281h-162.11v49.705h161.97v-2.4281h-159.54v-44.849h159.69zm-14.426-10.427v-9.284h-235.24v9.284h235.24m-2.4281-6.8559v4.4278h-230.39v-4.4278h230.39z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.89 34.335v-4.4278h-230.39v4.4278h230.39z",
    fill: "#999",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.23 67.044c0.71416 1.1426 2.7138 4.4278 5.8561 9.9982 3.428 6.1418 6.4274 11.569 9.284 16.283h5.1419l-17.711-30.852h-9.7125l-17.711 30.852h5.1419c2.7138-4.7134 5.8561-10.141 9.284-16.283 3.1423-5.4276 5.1419-8.8556 5.8561-9.9982h4.5706z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.88 94.467v-2.4281h-487.48v2.4281h487.48zm-441.21-25.424-5.8561-9.9982-5.8561 9.9982h11.712z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.54 58.331-6.8559 11.855h15.711l-7.7129-13.569-1.1426 1.714m-2.571 9.5697 3.5708-6.2846 3.5708 6.2846h-7.1416zm310.52-21.853-5.8561-10.141-5.8561 10.141h11.712z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.48 35.763-7.9986 11.284h15.997l-7.9986-11.284m-3.8564 9.284 3.8564-5.5704 3.8564 5.5704h-7.7129zm-61.275 7.2844v-16.997h-7.2844v16.997h7.2844zm186.11-30.423v-10.712h-7.2844v10.712h7.2844z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.03 27.765 6.5702-6.5702h-13.283l6.7131 6.5702zm-255.53 66.702v-18.711h-71.987v18.711h71.987m-2.4281-16.283v13.855h-67.131v-13.855h67.131z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.08 92.039v-13.855h-67.131v13.855h67.131z",
    fill: "#333",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.94 54.332h-5.2848v14.854h5.2848v-14.854m-2.9995 2.4281h0.42849v9.9982h-0.42849v-9.9982z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.49 60.33v-9.284h-275.38v9.284h275.38m-2.4281-6.8559v4.4278h-270.52v-4.4278h270.52z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.06 57.902v-4.4278h-270.52v4.4278h270.52z",
    fill: "#999",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4286 0 0 1.4283 563.5 20.245)",
    x: 13.29973,
    y: 4.90088,
    fontFamily: "'ArialMT'",
    fontSize: "15.279px",
    stroke: "null"
  }, "x"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4286 0 0 1.4283 292.12 80.734)",
    x: 13.29973,
    y: 4.90088,
    fontFamily: "'ArialMT'",
    fontSize: "15.279px",
    stroke: "null"
  }, "100 kg"), /*#__PURE__*/React.createElement("path", {
    d: "m169.67 188.31v-26.852h-65.274v2.4281h62.846v21.996h-62.846v2.4281h65.274zm422.07-47.563v-2.4281h-162.11v49.991h161.97v-2.4281h-159.54v-45.135h159.69zm-14.426-10.427v-8.9984h-235.24v8.9984h235.24m-2.4281-6.5702v4.1421h-230.39v-4.1421h230.39z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.89 127.89v-4.1421h-230.39v4.1421h230.39z",
    fill: "#999",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.08 160.74c0.71416 1.1426 2.7138 4.5706 5.8561 10.141 3.428 6.1418 6.4274 11.569 9.284 16.283h5.1419l-17.425-30.852h-9.7125l-17.711 30.852h5.1419c2.7138-4.7134 5.8561-10.141 9.284-16.283 3.1423-5.5704 5.1419-8.9984 5.8561-10.141h4.2849z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.88 188.31v-2.4281h-487.48v2.4281h487.48zm-441.21-25.71-5.8561-9.9982-5.8561 9.9982h11.712z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.54 151.89-6.8559 11.855h15.711l-7.7129-13.569-1.1426 1.714m-2.571 9.4269 3.5708-6.2846 3.5708 6.2846h-7.1416zm360.22-21.71-5.8561-10.141-5.8561 10.141h11.712z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.33 129.46-7.7129 11.284h15.711l-7.9986-11.284m-3.7136 9.284 3.7136-5.2848 3.7136 5.2848h-7.4272zm-111.27 7.4272v-16.997h-7.2844v16.997h7.2844zm186.11-30.28v-10.855h-7.2844v10.855h7.2844z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.03 121.75 6.5702-6.8559h-13.283l6.7131 6.8559zm-327.51 47.849v18.711h71.987v-18.711h-71.987m2.4281 16.283v-13.855h67.131v13.855h-67.131z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.95 172.02v13.855h67.131v-13.855h-67.131z",
    fill: "#333",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.94 148.17h-5.2848v14.854h5.2848v-14.854m-2.9995 2.4281h0.42849v9.9982h-0.42849v-9.9982z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.11 144.6v9.284h275.24v-9.284h-275.24m2.4281 6.8559v-4.4278h270.38v4.4278h-270.38z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.54 147.03v4.4278h270.38v-4.4278h-270.38z",
    fill: "#999",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4286 0 0 1.4283 563.5 113.8)",
    x: 13.29973,
    y: 4.90088,
    fontFamily: "'ArialMT'",
    fontSize: "15.279px",
    stroke: "null"
  }, "x"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4286 0 0 1.4283 292.12 174.36)",
    x: 13.29973,
    y: 4.90088,
    fontFamily: "'ArialMT'",
    fontSize: "15.279px",
    stroke: "null"
  }, "100 kg"), /*#__PURE__*/React.createElement("path", {
    d: "m169.67 282v-26.709h-65.274v2.4281h62.846v21.853h-62.846v2.4281h65.274zm422.07-47.706v-2.4281h-162.11v49.991h161.97v-2.4281h-159.54v-45.135h159.69zm-14.426-10.141v-9.284h-235.24v9.284h235.24m-2.4281-6.7131v4.4278h-230.39v-4.4278h230.39z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.89 221.73v-4.4278h-230.39v4.4278h230.39z",
    fill: "#999",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.08 254.3c0.71416 1.4283 2.7138 4.7134 5.8561 10.141 3.428 6.1418 6.4274 11.569 9.284 16.283h5.1419l-17.425-30.852h-9.7125l-17.711 30.852h5.1419c2.7138-4.7134 5.8561-10.141 9.284-16.283 3.1423-5.4276 5.1419-8.8556 5.8561-10.141h4.2849z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.88 282v-2.4281h-487.48v2.4281h487.48zm-441.21-25.567-5.8561-10.141-5.8561 10.141h11.712z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.68 243.87-7.9986 13.855h15.711l-7.7129-13.855m-3.8564 11.427 3.7136-6.4274 3.7136 6.4274h-7.4272zm408.93-22.139-5.8561-9.9982-5.8561 9.9982h11.712z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m552.03 234.44-1.1426-1.4283-6.8559-9.7125-6.8559 9.7125-1.1426 1.4283h15.997m-11.712-1.9996 3.7136-5.4276 3.7136 5.4276h-7.4272zm-159.97 7.2844v-16.997h-7.2844v16.997h7.2844zm186.11-30.28v-10.712h-7.2844v10.712h7.2844z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.03 215.3 6.5702-6.5702h-13.283l6.7131 6.5702zm-327.51 47.991v18.711h71.987v-18.711h-71.987m2.4281 16.14v-13.855h67.131v13.855h-67.131z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.95 265.72v13.855h67.131v-13.855h-67.131z",
    fill: "#333",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.94 241.87h-5.2848v14.854h5.2848v-14.854m-2.9995 2.4281h0.42849v9.9982h-0.42849v-9.9982z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.2 246.3v-6.5702h-272.81v6.5702h272.81z",
    fill: "red",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.11 238.44v8.9984h275.24v-8.9984h-275.24m2.4281 6.5702v-4.1421h270.38v4.1421h-270.38z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.54 240.87v4.1421h270.38v-4.1421h-270.38z",
    fill: "#999",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4286 0 0 1.4283 563.5 207.64)",
    x: 13.29973,
    y: 4.90088,
    fontFamily: "'ArialMT'",
    fontSize: "15.279px",
    stroke: "null"
  }, "x"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4286 0 0 1.4283 292.12 268.13)",
    x: 13.29973,
    y: 4.90088,
    fontFamily: "'ArialMT'",
    fontSize: "15.279px",
    stroke: "null"
  }, "100 kg"), /*#__PURE__*/React.createElement("path", {
    d: "m656.16 19.481c-3.428-3.428-7.4272-5.1419-12.284-5.1419s-8.9984 1.714-12.426 5.1419c-3.428 3.428-5.1419 7.5701-5.1419 12.426s1.714 8.9984 5.1419 12.426c3.428 3.428 7.5701 5.1419 12.426 5.1419s8.8556-1.714 12.284-5.1419c3.428-3.428 5.1419-7.5701 5.1419-12.426s-1.714-8.9984-5.1419-12.426z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4256 0 0 1.4283 747.46 87.19)",
    x: -76.59984,
    y: -33.78735,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "1"), /*#__PURE__*/React.createElement("path", {
    d: "m656.16 113.46c-3.428-3.428-7.4272-5.1419-12.284-5.1419s-8.9984 1.714-12.426 5.1419-5.1419 7.5701-5.1419 12.426 1.714 8.9984 5.1419 12.426c3.428 3.428 7.5701 5.1419 12.426 5.1419s8.8556-1.714 12.284-5.1419c3.428-3.428 5.1419-7.5701 5.1419-12.426s-1.714-8.9984-5.1419-12.426z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4256 0 0 1.4283 747.46 181.17)",
    x: -76.59984,
    y: -33.78735,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m656.16 207.45c-3.428-3.428-7.4272-5.1419-12.284-5.1419s-8.9984 1.714-12.426 5.1419c-3.428 3.428-5.1419 7.5701-5.1419 12.426s1.714 8.9984 5.1419 12.426c3.428 3.428 7.5701 5.1419 12.426 5.1419s8.8556-1.714 12.284-5.1419c3.428-3.428 5.1419-7.5701 5.1419-12.426s-1.714-8.9984-5.1419-12.426z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.4256 0 0 1.4283 747.46 275.16)",
    x: -76.59984,
    y: -33.78735,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem1A);
export default __webpack_public_path__ + "static/media/item1a.fe571e2e8ca4ee7d789e66060b03611a.svg";
export { ForwardRef as ReactComponent };